import styled from 'styled-components';
import Button from '../../../../../../../../components/Button';


const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 28px 0;
`;

const ActionButtonsContainer = styled.div`
  display: flex;  
`;

const StyledButton = styled(Button)`
  &:first-child {
    background: #C4C4C4;
    margin-right: 16px;
  }

  text-transform: uppercase;
`;

export const S = {
  StyledButton,
  FooterContainer,
  ActionButtonsContainer,
};
